import { defineStore, acceptHMRUpdate } from 'pinia'
import useState from './useState'
import useGetters from './useGetters'
import useActions from './useActions'
import { unref } from 'vue'

export const useUserStore = defineStore('userStore', () => {
  const store = {
    initialState: unref(useState()),
    ...useState(),
    ...useGetters(),
    ...useActions()
  }
  // useWatchers(store)
  return store
}, { persist: true })

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
